import React from 'react';
import { navigate } from 'gatsby';
import { useMeQuery } from '$/GraphQL/schema/schema';

export const RedirectIfUnauthenticated: React.FC = () => {
  const meQuery = useMeQuery();

  React.useEffect(() => {
    if (meQuery.called && !meQuery.data && !meQuery.loading) {
      navigate('/login');
    }
  }, [meQuery]);

  return null;
};
